export default __webpack_public_path__ + "static/media/auth_grid.280b0f53.png";